import withSequenceState from 'components/hoc/withSequenceState';
import ProgramFeedRedirectView from 'components/views/ProgramFeedRedirectView';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getCalendarToday } from 'store/programDays';
import { ProgramDayMinType } from 'store/programDays';

const mapStateToProps = (state) => ({
	currentDayNumber: ((calendar: ProgramDayMinType): number => {
		return calendar && calendar.dayNumber ? calendar.dayNumber : -1;
	})(getCalendarToday(state)!),
});

export default withRouter(
	(connect(mapStateToProps) as any)(withSequenceState(ProgramFeedRedirectView, [Sequences.CALENDAR_TODAY_IS_LOADING]))
);
